// Validation limits enforced by the backend Zod schemas in this package. Frontend imports from here
// so its client-side checks stay in lockstep with the backend.
// Shared by both bulk level endpoints (a role's expected levels, an assignee's current levels):
// each entry costs its own transaction, and the cap mirrors the read-side page cap.
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "MAX_BULK_LEVEL_ENTRIES", {
    enumerable: true,
    get: function() {
        return MAX_BULK_LEVEL_ENTRIES;
    }
});
const MAX_BULK_LEVEL_ENTRIES = 500;
